(function () {
  'use strict';

  var O = window.MMOffers || {};

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;');
  }

  function jp(raw, fallback) {
    if (O.jp) return O.jp(raw, fallback);
    if (raw == null) return fallback || [];
    if (Array.isArray(raw)) return raw;
    if (typeof raw === 'object') return raw;
    try { return JSON.parse(raw || '[]'); } catch (e) { return fallback || []; }
  }

  function configItems(raw) {
    if (O.configItems) return O.configItems(raw);
    var v = jp(raw, []);
    if (Array.isArray(v)) return v;
    if (v && typeof v === 'object') {
      var out = [];
      if (v.trigger) out.push(v.trigger);
      if (v.target) out.push(v.target);
      return out;
    }
    return [];
  }

  function shopRoot() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.endsWith('/') ? root.slice(0, -1) : root;
  }

  function t(en, ar, el) {
    return O.t ? O.t(en, ar, el) : en;
  }

  function firstHandle(offer) {
    var triggers = jp(offer.triggerProducts);
    if (triggers[0]) return triggers[0];
    var items = configItems(offer.bundleItemsConfig);
    if (items[0] && items[0].handle) return items[0].handle;
    return '';
  }

  function cardTitle(offer, el) {
    if (O.offerTitle) return O.offerTitle(offer, offer._prod, el);
    if (O.isAr && O.isAr(el) && offer.titleAr) return offer.titleAr;
    return offer.title || offer.name || (offer._prod ? offer._prod.title : '');
  }

  function sectionTitle(type, el) {
    if (type === 'BOGO') return t('Buy 1 Get 1', 'اشتري واحصل على واحد', el);
    if (type === 'BUNDLE') return t('Bundle deals', 'عروض الباقات', el);
    if (type === 'VOLUME') return t('Volume savings', 'خصم الكمية', el);
    if (type === 'DISCOUNTED_PRODUCT') return t('Special prices', 'أسعار خاصة', el);
    return t('Offers', 'عروض', el);
  }

  function typeBadge(type, el) {
    return O.typeLabel ? O.typeLabel(type, el) : type;
  }

  function flattenOffers(offers) {
    var out = [];
    var seen = new Set();
    (offers || []).forEach(function (o) {
      if (!o || seen.has(o.id)) return;
      if (o.type === 'CART_TIER_GIFT') return;
      seen.add(o.id);
      if (o.type === 'DISCOUNTED_PRODUCT') {
        if (o._isGlobal || String(o.id || '').indexOf('global-') === 0) {
          out.push(o);
          return;
        }
        configItems(o.bundleItemsConfig).forEach(function (item) {
          if (!item || !item.handle) return;
          out.push({
            id: o.id + '-' + (item._uid || item.id || item.handle),
            type: o.type,
            title: o.title,
            titleAr: o.titleAr,
            endsAt: o.endsAt,
            customerQuantity: o.customerQuantity,
            slug: o.slug,
            images: o.images,
            triggerProducts: JSON.stringify([item.handle]),
            _manual: item
          });
        });
        return;
      }
      out.push(o);
    });
    return out;
  }

  function collectHandles(offers) {
    var handles = {};
    offers.forEach(function (o) {
      jp(o.triggerProducts).forEach(function (h) { if (h) handles[h] = 1; });
      jp(o.targetProducts).forEach(function (h) { if (h) handles[h] = 1; });
      configItems(o.bundleItemsConfig).forEach(function (item) {
        if (!item) return;
        if (item.handle) handles[item.handle] = 1;
        if (item.type === 'choice_group') {
          (item.options || []).forEach(function (opt) { if (opt && opt.handle) handles[opt.handle] = 1; });
        }
      });
    });
    return handles;
  }

  function offerUrl(offer, handle) {
    if (O.offerNavUrl) return O.offerNavUrl(offer, 'bundles', handle || firstHandle(offer));
    var root = shopRoot();
    var h = handle || firstHandle(offer);
    if (offer && O.isCompareAtDeal && O.isCompareAtDeal(offer) && h) {
      var url = root + '/products/' + encodeURIComponent(h) + '?mm_ref=bundles';
      var manual = offer._manual || {};
      var vid = manual.selectedVariantId ? String(manual.selectedVariantId).split('/').pop() : '';
      if (!vid && O.variantIdFromOffer) vid = O.variantIdFromOffer(offer);
      if (vid) url += '&variant=' + encodeURIComponent(vid);
      return url;
    }
    var slug = offer.slug || '';
    if (!slug && offer.id && String(offer.id).indexOf('global-') !== 0) slug = offer.id;
    if (slug) return root + '/pages/offer?slug=' + slug + '&mm_ref=bundles';
    if (h) return root + '/products/' + encodeURIComponent(h) + '?mm_ref=bundles';
    return root + '/pages/bundles?mm_ref=bundles';
  }

  function prodImg(p) {
    if (!p) return '';
    if (typeof p.featured_image === 'string') return p.featured_image;
    if (p.featured_image && p.featured_image.src) return p.featured_image.src;
    if (p.images && p.images[0]) return typeof p.images[0] === 'string' ? p.images[0] : '';
    return '';
  }

  function itemImage(item, cache) {
    if (item && item.image) return item.image;
    if (item && item.handle && cache[item.handle]) return prodImg(cache[item.handle]);
    return '';
  }

  async function fetchOffersApi() {
    if (O.loadOffersList) return O.loadOffersList();
    try {
      var url = O.offersApiUrl ? O.offersApiUrl() : '/apps/mm-app/api/offers';
      var res = await fetch(url);
      return res.ok ? res.json() : { offers: [], settings: {} };
    } catch (e) {
      return { offers: [], settings: {} };
    }
  }

  function buildGroupedHtml(offers, cache, mount, settings) {
    var order = ['BOGO', 'BUNDLE', 'VOLUME', 'DISCOUNTED_PRODUCT'];
    var grouped = {};
    offers.forEach(function (o) {
      var key = o.type || 'OTHER';
      if (!grouped[key]) grouped[key] = [];
      grouped[key].push(o);
    });
    var html = '';
    order.forEach(function (type) {
      var list = grouped[type];
      if (!list || !list.length) return;
      html += '<section class="mmo-bundles-feed__group mmo-bundles-feed__group--' + type.toLowerCase() + '">' +
        '<header class="mmo-bundles-feed__group-head">' +
          '<div class="mmo-bundles-feed__group-label">' +
            '<span class="mmo-bundles-feed__group-icon" aria-hidden="true"></span>' +
            '<h2 class="mmo-bundles-feed__group-title">' + esc(sectionTitle(type, mount)) +
              '<span class="mmo-bundles-feed__group-count">' + list.length + '</span>' +
            '</h2>' +
          '</div>' +
        '</header>' +
        '<div class="mmo-bundles-feed__list">' +
          list.map(function (o) { return renderCard(o, cache, mount, settings); }).join('') +
        '</div>' +
      '</section>';
    });
    return html;
  }

  async function fetchProduct(handle) {
    if (!handle) return null;
    if (O.fetchProductJs) return O.fetchProductJs(handle);
    try {
      var r = await fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' });
      return r.ok ? r.json() : null;
    } catch (e) {
      return null;
    }
  }

  async function loadProductCache(handles) {
    var cache = {};
    var keys = Object.keys(handles);
    for (var i = 0; i < keys.length; i += 6) {
      var batch = keys.slice(i, i + 6);
      var batchRes = await Promise.all(batch.map(fetchProduct));
      batch.forEach(function (k, j) { if (batchRes[j]) cache[k] = batchRes[j]; });
    }
    return cache;
  }

  async function productForItem(item, cache) {
    if (!item) return null;
    if (item.type === 'choice_group') {
      var opts = item.options || [];
      for (var i = 0; i < opts.length; i++) {
        if (opts[i] && opts[i].handle) {
          var p = cache[opts[i].handle] || await fetchProduct(opts[i].handle);
          if (p) return p;
        }
      }
      return null;
    }
    if (!item.handle) return null;
    return cache[item.handle] || await fetchProduct(item.handle);
  }

  async function enrichOffer(offer, cache) {
    var handle = firstHandle(offer);
    offer._prod = handle ? (cache[handle] || await fetchProduct(handle)) : null;
    if (offer._prod && handle) cache[handle] = offer._prod;

    if (!offer._manual && (offer._isGlobal || String(offer.id || '').indexOf('global-') === 0)) {
      var cfgItems = configItems(offer.bundleItemsConfig);
      if (cfgItems[0]) offer._manual = cfgItems[0];
    }

    if ((offer._isGlobal || String(offer.id || '').indexOf('global-') === 0) && offer._prod && O.compareAtDealImage) {
      var resolvedImg = O.compareAtDealImage(offer, offer._prod);
      if (resolvedImg && offer._manual) offer._manual.image = resolvedImg;
    }

    if (offer.type === 'BUNDLE' || offer.type === 'BOGO') {
      var items = configItems(offer.bundleItemsConfig);
      offer._bundleProducts = await Promise.all(items.map(function (item) {
        return productForItem(item, cache);
      }));
      offer._bundleProducts.forEach(function (p, idx) {
        var it = items[idx];
        if (p && it && it.handle) cache[it.handle] = p;
      });
    }
    return offer;
  }

  function savePct(price, compare) {
    if (!compare || compare <= price) return 0;
    return Math.round((1 - price / compare) * 100);
  }

  function priceSpan(minor, el) {
    if (O.priceSpan) return O.priceSpan(minor, el);
    minor = parseInt(minor, 10) || 0;
    var div = 100;
    if (el && el.getAttribute) {
      var d = parseInt(el.getAttribute('data-money-divisor'), 10);
      if (d === 100 || d === 1000) div = d;
    }
    var htmlDiv = parseInt(document.documentElement.getAttribute('data-mm-money-divisor'), 10);
    if (htmlDiv === 100 || htmlDiv === 1000) div = htmlDiv;
    var text = String(minor);
    if (window.mmCurrencyConfig && typeof window.mmCurrencyConfig.formatWithTax === 'function') {
      text = window.mmCurrencyConfig.formatWithTax(minor, div);
    } else if (O.fmtPrice) {
      text = O.fmtPrice(minor, el);
    } else {
      var taxed = minor;
      if (window.mmTaxConfig && typeof window.mmTaxConfig.applyTax === 'function') {
        taxed = Math.round(window.mmTaxConfig.applyTax(minor));
      }
      var amt = (taxed / div).toFixed(3);
      text = (O.isAr && O.isAr(el)) ? (amt + ' د.ب') : ('BHD ' + amt);
    }
    return '<span class="mm-taxed-price" data-original-price="' + minor + '" data-mm-divisor="' + div + '">' + esc(text) + '</span>';
  }

  function heroImage(offer, cache) {
    if (O.isCompareAtDeal && O.isCompareAtDeal(offer)) {
      var compareImg = O.compareAtDealImage ? O.compareAtDealImage(offer, offer._prod) : '';
      if (compareImg) return compareImg;
      return '';
    }

    var imgs = [];
    jp(offer.images).forEach(function (u) { if (u) imgs.push(u); });
    configItems(offer.bundleItemsConfig).forEach(function (item) {
      var u = itemImage(item, cache);
      if (u && imgs.indexOf(u) < 0) imgs.push(u);
    });
    if (!imgs.length && offer._prod) {
      var pi = prodImg(offer._prod);
      if (pi) imgs.push(pi);
    }
    return imgs[0] || '';
  }

  function includedThumbsHtml(offer, cache) {
    if (offer.type !== 'BUNDLE' && offer.type !== 'BOGO') return '';
    var items = configItems(offer.bundleItemsConfig);
    var prods = offer._bundleProducts || [];
    var thumbs = [];
    items.forEach(function (item, i) {
      if (!item) return;
      var img = itemImage(item, cache) || prodImg(prods[i]);
      var label = item.title || (prods[i] && prods[i].title) || '';
      if (img) thumbs.push({ img: img, label: label });
    });
    if (thumbs.length < 2) return '';
    var html = '<div class="mmo-showcase__thumbs">';
    thumbs.slice(0, 4).forEach(function (th) {
      html += '<span class="mmo-showcase__thumb" title="' + esc(th.label) + '">' +
        '<img src="' + esc(th.img) + '" alt="" loading="lazy" width="36" height="36">' +
      '</span>';
    });
    if (thumbs.length > 4) {
      html += '<span class="mmo-showcase__thumb mmo-showcase__thumb--more">+' + (thumbs.length - 4) + '</span>';
    }
    html += '</div>';
    return html;
  }

  function bodyMetaHtml(offer, el, settings) {
    var parts = [];
    if (offer.endsAt) {
      parts.push(
        '<div class="mmo-showcase__meta-item mmo-showcase__meta-item--timer">' +
          '<span class="mmo-showcase__meta-icon" aria-hidden="true">⏱</span>' +
          '<span class="mmo-showcase__meta-label">' + esc(t('Ends in', 'ينتهي خلال', el)) + '</span>' +
          '<span class="mmo-showcase__meta-val" data-ends-at="' + esc(offer.endsAt) + '"></span>' +
        '</div>'
      );
    }
    if (offer.customerQuantity > 0) {
      var stock = O.stockLabel
        ? O.stockLabel(offer.customerQuantity, settings, el)
        : t('Only ' + offer.customerQuantity + ' left', 'متبقي ' + offer.customerQuantity + ' فقط', el);
      parts.push(
        '<div class="mmo-showcase__meta-item mmo-showcase__meta-item--stock">' +
          '<span class="mmo-showcase__meta-icon" aria-hidden="true">🔥</span>' +
          '<span class="mmo-showcase__meta-val">' + esc(stock) + '</span>' +
        '</div>'
      );
    }
    if (!parts.length) return '';
    return '<div class="mmo-showcase__meta-bar">' + parts.join('') + '</div>';
  }

  function mediaOverlayHtml(offer, el, settings) {
    return bodyMetaHtml(offer, el, settings);
  }

  function pricingBoxHtml(offer, el) {
    var prices = O.offerPrices
      ? O.offerPrices(offer, offer._prod, el)
      : { price: offer._prod ? offer._prod.price : 0, compare: offer._prod ? offer._prod.compare_at_price : 0 };

    if (offer.type === 'VOLUME') {
      var maxPct = prices.maxPct || (O.volumeMaxPct ? O.volumeMaxPct(offer) : 0);
      if (prices.price > 0 || maxPct > 0) {
        return '<div class="mmo-showcase__pricebox mmo-showcase__pricebox--volume">' +
          (prices.price > 0
            ? '<div class="mmo-showcase__price-row">' +
                '<span class="mmo-showcase__price-label">' + esc(t('From', 'يبدأ من', el)) + '</span>' +
                '<span class="mmo-showcase__price-now">' + priceSpan(prices.price, el) + '</span>' +
              '</div>'
            : '') +
          (maxPct > 0
            ? '<span class="mmo-showcase__save mmo-showcase__save--upto">' +
                esc(t('Up to ' + maxPct + '% off', 'يصل إلى ' + maxPct + '%', el)) +
              '</span>'
            : '') +
        '</div>';
      }
    }

    if (offer.type === 'BOGO' && prices.price <= 0) {
      var bogo = O.bogoLabel ? O.bogoLabel(offer, el) : t('Buy 1 Get 1', 'اشتري واحصل على واحد', el);
      return '<div class="mmo-showcase__pricebox mmo-showcase__pricebox--bogo">' +
        '<span class="mmo-showcase__deal">' + esc(bogo) + '</span>' +
      '</div>';
    }

    if (prices.price > 0) {
      var pct = savePct(prices.price, prices.compare);
      var priceLabel = offer.type === 'BOGO'
        ? t('You pay', 'تدفع', el)
        : t('Offer price', 'سعر العرض', el);
      var wasLabel = offer.type === 'BOGO'
        ? t('Regular', 'بدلاً من', el)
        : t('Was', 'بدلاً من', el);
      return '<div class="mmo-showcase__pricebox' + (offer.type === 'BOGO' ? ' mmo-showcase__pricebox--bogo' : '') + '">' +
        '<div class="mmo-showcase__price-row">' +
          '<span class="mmo-showcase__price-label">' + esc(priceLabel) + '</span>' +
          '<span class="mmo-showcase__price-now">' + priceSpan(prices.price, el) + '</span>' +
        '</div>' +
        (prices.compare > prices.price
          ? '<div class="mmo-showcase__price-row mmo-showcase__price-row--was">' +
              '<span class="mmo-showcase__price-label">' + esc(wasLabel) + '</span>' +
              '<span class="mmo-showcase__price-was">' + priceSpan(prices.compare, el) + '</span>' +
            '</div>'
          : '') +
        (pct > 0
          ? '<span class="mmo-showcase__save">' + esc(t('Save ' + pct + '%', 'وفر ' + pct + '%', el)) + '</span>'
          : '') +
      '</div>';
    }

    return '';
  }

  function ctaHtml(offer, el) {
    var typeKey = (offer.type || 'offer').toLowerCase();
    return '<span class="mmo-showcase__cta mmo-showcase__cta--' + esc(typeKey) + '">' +
      '<span class="mmo-showcase__cta-text">' + esc(ctaLabel(offer, el)) + '</span>' +
      '<svg class="mmo-showcase__cta-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><path d="M9 18l6-6-6-6"/></svg>' +
    '</span>';
  }

  function subtitle(offer, el) {
    if (offer._isGlobal || (String(offer.id || '').indexOf('global-') === 0 && offer.type === 'DISCOUNTED_PRODUCT')) {
      var vt = O.variantLabelFromOffer ? O.variantLabelFromOffer(offer, el) : '';
      if (vt && vt.indexOf('variants') === -1) return vt;
    }
    var items = configItems(offer.bundleItemsConfig);
    if (offer.type === 'BUNDLE' && items.length) {
      return t(items.length + ' products in bundle', items.length + ' منتجات في الباقة', el);
    }
    if (offer.type === 'BOGO') {
      return O.bogoLabel ? O.bogoLabel(offer, el) : t('Buy 1 · Get 1 free', 'اشتري 1 · احصل على 1 مجاناً', el);
    }
    if (offer.type === 'VOLUME') {
      return t('Buy more, save more', 'اشتري أكثر واحصل على خصم أكبر', el);
    }
    return '';
  }

  function ctaLabel(offer, el) {
    if (offer.type === 'VOLUME' || offer.type === 'DISCOUNTED_PRODUCT') {
      return t('View product', 'عرض المنتج', el);
    }
    return t('View offer', 'عرض التفاصيل', el);
  }

  function renderCard(offer, cache, el, settings) {
    var handle = firstHandle(offer);
    var title = cardTitle(offer, el);
    var url = offerUrl(offer, handle);
    var typeKey = (offer.type || 'offer').toLowerCase();
    var img = heroImage(offer, cache);
    var sub = subtitle(offer, el);

    return '<a href="' + esc(url) + '" class="mmo-showcase mmo-showcase--' + esc(typeKey) + '">' +
      '<div class="mmo-showcase__media">' +
        (img
          ? '<img src="' + esc(img) + '" alt="' + esc(title) + '" loading="lazy" class="mmo-showcase__img" width="400" height="400">'
          : '<span class="mmo-showcase__img-ph" aria-hidden="true"></span>') +
        '<span class="mmo-showcase__ribbon">' + esc(typeBadge(offer.type, el)) + '</span>' +
      '</div>' +
      '<div class="mmo-showcase__body">' +
        '<h3 class="mmo-showcase__title">' + esc(title || t('View offer', 'عرض', el)) + '</h3>' +
        (sub ? '<p class="mmo-showcase__sub">' + esc(sub) + '</p>' : '<p class="mmo-showcase__sub mmo-showcase__sub--spacer" aria-hidden="true">&nbsp;</p>') +
        bodyMetaHtml(offer, el, settings) +
        includedThumbsHtml(offer, cache) +
        pricingBoxHtml(offer, el) +
        ctaHtml(offer, el) +
      '</div>' +
    '</a>';
  }

  function wireTimers(root, el) {
    if (!O.startTimer) return;
    root.querySelectorAll('[data-ends-at]').forEach(function (node) {
      O.startTimer(node.getAttribute('data-ends-at'), node, el);
    });
  }

  function settle(mount, html) {
    mount.innerHTML = html;
    wireTimers(mount, mount);
    mount.classList.remove('is-loading');
    mount.classList.add('is-ready');
    if (O.hydratePrices) O.hydratePrices(mount);
    else if (window.mmCurrencyConfig && typeof window.mmCurrencyConfig.refreshPrices === 'function') {
      window.mmCurrencyConfig.refreshPrices();
    }
    if (O.warmOfferUrls) {
      var urls = [];
      mount.querySelectorAll('a[href*="/pages/bundles"], a[href*="/pages/offer"], a[href*="/apps/mm-app/offers/"]').forEach(function (a) {
        if (a.href) urls.push(a.href);
      });
      O.warmOfferUrls(urls.slice(0, 6), { prerenderCount: 2 });
    }
  }

  async function waitForLib() {
    if (window.MMOffers && window.MMOffers.priceSpan) return;
    var deadline = Date.now() + 600;
    while (Date.now() < deadline) {
      if (window.MMOffers && window.MMOffers.priceSpan) return;
      await new Promise(function (r) { setTimeout(r, 30); });
    }
  }

  async function quickOffersApi() {
    if (O.quickOffersList) return O.quickOffersList(500);
    if (O.loadOffersList) return O.loadOffersList({ maxWait: 800 });
    return fetchOffersApi();
  }

  async function init() {
    var mount = document.querySelector('[data-mm-bundles-feed]');
    if (!mount) return;
    O = window.MMOffers || O;

    var emptyText = mount.getAttribute('data-empty-text') || 'No offers available right now';

    async function paintFrom(apiRes) {
      var settings = (apiRes && apiRes.settings) || {};
      var flat = flattenOffers((apiRes && apiRes.offers) || []);
      var expandFn = O.expandCompareAtOffers;
      var offers = expandFn ? await expandFn(flat, fetchProduct) : flat;
      if (!offers.length) {
        settle(mount, '<p class="mmo-bundles-feed__empty">' + esc(emptyText) + '</p>');
        return null;
      }
      var htmlQuick = buildGroupedHtml(offers, {}, mount, settings);
      settle(mount, htmlQuick);
      if (O.wireOfferNavigation) O.wireOfferNavigation();
      return offers;
    }

    try {
      var cached = window.__mmPrefetch && window.__mmPrefetch.cache && window.__mmPrefetch.cache.offers;
      var offers = null;
      if (cached && cached._ok) {
        offers = await paintFrom(cached);
      } else if (window.__mmOffersPreload) {
        var pre = await Promise.race([
          window.__mmOffersPreload,
          new Promise(function (r) { setTimeout(function () { r(null); }, 400); })
        ]);
        if (pre) offers = await paintFrom(pre);
      }

      fetchOffersApi().then(async function (fullRes) {
        var painted = await paintFrom(fullRes);
        if (!painted || !painted.length) return;
        var fullSettings = (fullRes && fullRes.settings) || {};
        var expandFn = O.expandCompareAtOffers;
        var flat = flattenOffers((fullRes && fullRes.offers) || painted);
        var fullOffers = expandFn ? await expandFn(flat, fetchProduct) : flat;
        return loadProductCache(collectHandles(fullOffers)).then(function (cache) {
          return Promise.all(fullOffers.map(function (o) { return enrichOffer(o, cache); })).then(function (enriched) {
            return { enriched: enriched, cache: cache, settings: fullSettings };
          });
        });
      }).then(function (payload) {
        if (!payload || !document.body.contains(mount)) return;
        var html = buildGroupedHtml(payload.enriched, payload.cache, mount, payload.settings);
        if (html) settle(mount, html);
        if (O.wireOfferNavigation) O.wireOfferNavigation();
      }).catch(function (err) {
        console.warn('[MM Bundles Page] enrich', err);
      });

      if (!offers) {
        var apiRes = await fetchOffersApi();
        await paintFrom(apiRes);
      }
    } catch (err) {
      console.error('[MM Bundles Page]', err);
      settle(mount, '<p class="mmo-bundles-feed__empty">' + esc(emptyText) + '</p>');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
